module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm1",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063779_Preface#sec1"
    }
  }, [_c('i', [_vm._v("Preface / Michael Dylan Foster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063779_Chapter01#sec2"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Introduction: We Are All Survivors / Carl Lindahl")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter02#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Into the Bullring: The Significance of “Empathy” after the Earthquake / Yutaka Suga")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Rebuilding and Reconnecting after Disaster: Listening to Older Adults / Yoko Taniguchi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter04#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("The Story of Cultural Assets and Their Rescue: A Firsthand Report from Tohoku / Kōji Katō")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter05#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Critical Empathy: A Survivor’s Study of Disaster / Kate Parker Horigan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter06#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Empathy and Speaking Out / Amy Shuman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter07#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("The Intangible Lightness of Heritage / Michael Dylan Foster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Chapter08#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Documenting Disaster Folklore in the Eye of the Storm: Six Months after María / Gloria M. Colom Braña")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Conclusion#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The COVID-19 Pandemic and “Folklife’s First Responders” / Georgia Ellie Dassler, with Kate Parker Horigan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253063779_Index#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f402e39a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253063779_Contents.vue
// module id = 66
// module chunks = 0